// assets/utils-enhanced.js - Sistema completo de utilidades
// Sistema de Notificaciones Toast
const ToastSystem = {
  container: null,

  init() {
    if (this.container) return;

    this.container = document.createElement('div');
    this.container.id = 'toast-container';
    this.container.className = 'fixed top-4 right-4 z-[9999] space-y-2 pointer-events-none';
    this.container.setAttribute('aria-live', 'polite');
    this.container.setAttribute('aria-atomic', 'true');
    document.body.appendChild(this.container);
  },

  show(message, type = 'info', duration = 3000) {
    this.init();

    const toast = document.createElement('div');
    toast.className = `toast-notification pointer-events-auto transform transition-all duration-300 translate-x-full opacity-0`;

    const icons = {
      success: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>',
      error: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>',
      warning: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>',
      info: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>'
    };

    const colors = {
      success: 'bg-green-50 text-green-800 border-green-200',
      error: 'bg-red-50 text-red-800 border-red-200',
      warning: 'bg-yellow-50 text-yellow-800 border-yellow-200',
      info: 'bg-blue-50 text-blue-800 border-blue-200'
    };

    toast.innerHTML = `
      <div class="flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border ${colors[type] || colors.info} min-w-[300px] max-w-md">
        <div class="flex-shrink-0">
          ${icons[type] || icons.info}
        </div>
        <p class="text-sm font-medium flex-1">${message}</p>
        <button onclick="this.closest('.toast-notification').remove()" class="flex-shrink-0 hover:opacity-70 transition-opacity" aria-label="Cerrar">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    `;

    this.container.appendChild(toast);

    // Trigger animation
    setTimeout(() => {
      toast.classList.remove('translate-x-full', 'opacity-0');
      toast.classList.add('translate-x-0', 'opacity-100');
    }, 10);

    // Auto remove
    if (duration > 0) {
      setTimeout(() => {
        toast.classList.add('translate-x-full', 'opacity-0');
        setTimeout(() => toast.remove(), 300);
      }, duration);
    }

    return toast;
  }
};

// Funciones globales de notificación
window.showNotification = (message, type = 'info', duration = 3000) => {
  return ToastSystem.show(message, type, duration);
};

// Loading Spinner System
const SpinnerSystem = {
  spinner: null,
  count: 0,

  init() {
    if (this.spinner) return;

    this.spinner = document.createElement('div');
    this.spinner.id = 'global-spinner';
    this.spinner.className = 'fixed inset-0 z-[9998] hidden items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm';
    this.spinner.innerHTML = `
      <div class="spinner-content bg-white rounded-lg p-6 shadow-2xl">
        <div class="flex flex-col items-center gap-3">
          <div class="spinner-ring"></div>
          <p class="text-gray-700 font-medium">Cargando...</p>
        </div>
      </div>
    `;
    document.body.appendChild(this.spinner);
  },

  show() {
    this.init();
    this.count++;
    if (this.count === 1) {
      this.spinner.classList.remove('hidden');
      this.spinner.classList.add('flex');
      document.body.style.overflow = 'hidden';
    }
  },

  hide() {
    this.count = Math.max(0, this.count - 1);
    if (this.count === 0 && this.spinner) {
      this.spinner.classList.add('hidden');
      this.spinner.classList.remove('flex');
      document.body.style.overflow = '';
    }
  },

  reset() {
    this.count = 0;
    this.hide();
  }
};

// Funciones globales de spinner
window.showSpinner = () => SpinnerSystem.show();
window.hideSpinner = () => SpinnerSystem.hide();

// Utilidad de debounce
window.debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Utilidad de throttle
window.throttle = (func, limit) => {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

// Format Money Helper
window.formatMoney = (cents, format = 'Gs. {{amount}}') => {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, format);
  }

  const value = (cents / 100).toFixed(0);
  return format.replace('{{amount}}', value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
};

// Local Storage Helper con try/catch
window.safeLocalStorage = {
  get(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return defaultValue;
    }
  },

  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error('Error writing to localStorage:', error);
      return false;
    }
  },

  remove(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Error removing from localStorage:', error);
      return false;
    }
  }
};

// Focus Trap for Modals
window.trapFocus = (element) => {
  const focusableElements = element.querySelectorAll(
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  const handleTabKey = (e) => {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        lastFocusable.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        firstFocusable.focus();
        e.preventDefault();
      }
    }
  };

  element.addEventListener('keydown', handleTabKey);

  return () => element.removeEventListener('keydown', handleTabKey);
};

// Scroll Lock for Modals
window.lockScroll = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbarWidth}px`;
};

window.unlockScroll = () => {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
};

// Inicializar al cargar
document.addEventListener('DOMContentLoaded', () => {
  ToastSystem.init();
  SpinnerSystem.init();
  // Utils Enhanced initialized
});
